/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import api from './api';
import { API_ENDPOINTS } from '../api/endpoints';

export const itemService = {
  listItems: (params?: any) => api.get(API_ENDPOINTS.ITEMS.LIST, { params }),
  getItemDetails: (id: string | number) => api.get(API_ENDPOINTS.ITEMS.DETAILS(id)),
  createItem: (data: any) => api.post(API_ENDPOINTS.ITEMS.CREATE, data),
  updateItem: (id: string | number, data: any) => api.put(API_ENDPOINTS.ITEMS.UPDATE(id), data),
  deleteItem: (id: string | number) => api.delete(API_ENDPOINTS.ITEMS.DELETE(id)),
  
  getMyItems: () => api.get(API_ENDPOINTS.ME.ITEMS),
  getDashboard: () => api.get(API_ENDPOINTS.ME.DASHBOARD),
  
  getCategories: () => api.get(API_ENDPOINTS.CATEGORIES.LIST),
  
  getTrendingItems: (limit: number = 6) => api.get(API_ENDPOINTS.ITEMS.LIST, { params: { sort: 'trending', limit } }),
  
  searchItems: (query: string, lat?: number, lng?: number, radius?: number) => 
    api.get(API_ENDPOINTS.SEARCH(query, lat, lng, radius)),
};
